import { type RouteObject } from 'react-router';
import MainLayout from '../layouts/MainLayout';
import { adminRoutes } from './routes/admin.routes';
import { archiveRoutes } from './routes/archive.routes';
import { authRoutes } from './routes/auth.routes';
import { consultantRoutes } from './routes/consultant.routes';
import { customersRoutes } from './routes/customers.routes';
import { docGenerationRoutes } from './routes/doc-generation.routes';
import { documentsRoutes } from './routes/documents.routes';
import { goodsReceivingRoutes } from './routes/goods-receiving.routes';
import { haccpRoutes } from './routes/haccp.routes';
import { labelsRoutes } from './routes/labels.routes';
import { mySitesRoutes } from './routes/my-sites.routes';
import { notificationsRoutes } from './routes/notifications.routes';
import { regulatoryNewsRoutes } from './routes/regulatory-news.routes';
import { selfCheckRoutes } from './routes/self-check.routes';
import { settingsRoutes } from './routes/settings.routes';
import { surveysRoutes } from './routes/surveys.routes';
import { teamRoutes } from './routes/team.routes';
import { warehouseRoutes } from './routes/warehouse.routes';

// ponytail: un unico MainLayout layout-route wrappa tutti i domini. La shell
// (navbar + SideDrawer + main container) viene montata UNA volta sola invece
// di rimontare ad ogni navigazione cross-route — il che causava la perdita
// dello scroll del drawer. I `element: <MainLayout />` residui nei singoli
// route file, quando annidati, delegano al permission gate (InsideMainLayout
// Context in MainLayout.tsx) preservando l'ordine originale dei check.
export const protectedRoutes: RouteObject[] = [
  {
    element: <MainLayout />,
    children: [
      ...authRoutes,
      ...settingsRoutes,
      ...documentsRoutes,
      ...docGenerationRoutes,
      ...haccpRoutes,
      ...notificationsRoutes,
      ...labelsRoutes,
      ...selfCheckRoutes,
      ...goodsReceivingRoutes,
      ...regulatoryNewsRoutes,
      ...warehouseRoutes,
      ...archiveRoutes,
      ...customersRoutes,
      ...teamRoutes,
      ...surveysRoutes,
      ...adminRoutes,
      ...consultantRoutes,
      ...mySitesRoutes,
    ],
  },
];
